module.exports = __webpack_public_path__ + "static/media/page2_furba4.ffe8acf0.wav";